import React from "react";
import Link from "gatsby-link";

const SocialNav = () => (
	<nav className="social-nav">
		<button className="menu-toggle">
			<span className="screen-reader-text">Click to toggle the menu</span>
		</button>
		<ul>
			<li>
				<Link to="https://www.github.com/andylincoln">Github</Link>
			</li>
			<li>
				<Link to="https://www.twitter.com/andy__lincoln">Twitter</Link>
			</li>
			<li>
				<Link to="https://www.linkedin.com/in/andrewlincoln1/">
					LinkedIn
				</Link>
			</li>
			<li>
				<Link to="http://instagram.com/andy_lincoln">Instagram</Link>
			</li>
		</ul>
	</nav>
);

export default SocialNav;



// WEBPACK FOOTER //
// ./src/components/Nav/social.js